import React, { useEffect, useState } from "react";
import Box from "../../../../../common/box/Box";
import { cleanJoin } from "../../../../../utils/stringUtil";
import { statusColor } from "./DocumentUpload";

function Document({
  uploadStatus,
  renderDocumentTitle,
  renderDocumentUploadProgress,
  renderDocumentUploadButton,
  className = "",
}) {
  const [leftBorder, setLeftBorder] = useState(`has-border-left-${statusColor(uploadStatus)}-6`);

  useEffect(() => {
    setLeftBorder(`has-border-left-${statusColor(uploadStatus)}-6`);
  }, [uploadStatus]);

  return (
    <Box className={cleanJoin(leftBorder, className)}>
      <div className="columns is-vcentered">
        <div className="column is-7 is-centered pl-0 pt-4 pb-4">
          {renderDocumentTitle && renderDocumentTitle()}
        </div>
        <div className="column is-3 is-size-7">
          {renderDocumentUploadProgress && renderDocumentUploadProgress()}
        </div>
        <div className="column is-2 has-text-right">
          {renderDocumentUploadButton && renderDocumentUploadButton()}
        </div>
      </div>
    </Box>
  );
}

export default Document;
